export default __webpack_public_path__ + "static/media/node.ca7d5097.svg";